module.exports = __webpack_public_path__ + "static/Branding-brief-63f4fef6cc26d7b2baa7f47e7762d3ad.pdf";